module.exports = __webpack_public_path__ + "img/SNOW_bg.6954645c.png";